<div *ngIf="!isListMode">
  <div class="content-wrapper" *ngIf="!displayQuestionType">
    <div class="btn-wrapper">
      <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
        <span>{{'questions.typeOfQuestions.surveyMultipleResp.btnBack' | translate}}</span>
      </button>
      <span class="spacer"></span>
      <button [disabled]="!surveyMultiResposeForm.valid" mat-flat-button color="" class="btn-primary" aria-label="Save"
        (click)='saveSurveyQuestion()'>
        <span>{{'questions.typeOfQuestions.surveyMultipleResp.btnSave' | translate}}</span>
      </button>
    </div>
    <form [formGroup]="surveyMultiResposeForm">
      <ng-container>
        <div class="filter-section">
          <div class="body-section title addFlex">
            <mat-icon>library_add</mat-icon> &nbsp;
            <span>{{'questions.typeOfQuestions.surveyMultipleResp.title' | translate}}</span>
          </div>
          <div class="body-section-2" formGroupName="questiondescription">
            <label class="que-label">{{'questions.typeOfQuestions.surveyMultipleResp.labelQuest' | translate}}</label>
            <ckeditor #myEditor formControlName="description" [editor]="Editor" (click)="onClick(true)"(ready)="onReady($event)"></ckeditor>
            <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <!-- <ckeditor  formControlName="description" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->
          </div>
        </div>
        <div *ngIf="validateQuestion" class="text-msg">
          <span>{{'questions.typeOfQuestions.surveyMultipleResp.errorQuestion' | translate}}</span>
        </div>
      </ng-container>
      <div>
        <div class="filter-section">
          <div class="body-section title">
            <span>{{'questions.typeOfQuestions.surveyMultipleResp.labelOption' | translate}}</span>
          </div>
        </div>
        <div class="body-section-2">
          <ckeditor #myEditor1 formControlName="tempOption" [editor]="Editor" (ready)="onReadyOption($event)"></ckeditor>
          <div *ngIf="errorMessageOption" class="alert alert-danger">{{ errorMessageOption }}</div>
          <!-- <ckeditor formControlName="tempOption" data="Enter here..." [config]="ckeditorConfig"></ckeditor> -->
          <!-- <ngx-editor-menu [editor]="optionEditor" [toolbar]="toolbar">
          </ngx-editor-menu>
          <ngx-editor [placeholder]="'Enter here...'" formControlName="tempOption" [editor]="optionEditor">
          </ngx-editor> -->
        </div>
        <div class="btn-container">
          <button mat-flat-button color="" class="btn-warn" (click)='validateAndAddOption()'>{{'questions.typeOfQuestions.surveyMultipleResp.btnAddOptions' | translate}}
          </button>
        </div>
        <div class="body-section-2">
          <div class="score-wrapper" *ngIf="showOptions" cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
            <div class="add-option" *ngFor="let o of this.surveyMultiResposeForm.controls[reuseProp.options].value; let i = index" cdkDrag>
              <div class="input-class-container">
                <mat-checkbox class="radio-btn-class" type="radio" [checked]="o?.answerValid==true" [value]="o" id="o{{i}}" name="o"
                  (change)="onCheckRadioOption($event)">
                </mat-checkbox>
                <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description | sanitizeHtml"></ng-component>
                <div class="drag-box" *cdkDragPreview>
                  <span [innerHtml]="o?.answerDescription?.description"></span>
                </div>
              </div>
              <div class="mat-icon-div">
                <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.surveyMultipleResp.addOptions.toolTip.edit' | translate}}"
                 (click)="openDialog(o)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.surveyMultipleResp.addOptions.toolTip.delete' | translate}}"
                 [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}"
                  (click)="removeArrayItem(i, reuseProp.options)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
                <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openDialog(o)">
                    <mat-icon>edit</mat-icon>
                    <span>
                      {{'questions.typeOfQuestions.surveyMultipleResp.addOptions.toolTip.edit' | translate}}
                    </span>
                  </button>
                  <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true"
                    (click)="removeArrayItem(i, reuseProp.options)">
                    <mat-icon>delete_outline</mat-icon>
                    <span>
                      {{'questions.typeOfQuestions.surveyMultipleResp.addOptions.toolTip.delete' | translate}}
                    </span>
                  </button>
                </mat-menu> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="exp-panel">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'questions.typeOfQuestions.surveyMultipleResp.accordian.title' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-2 answers-label">
                  <div class="form-label">
                    <label>{{'questions.typeOfQuestions.surveyMultipleResp.accordian.selectOptions.option1.label' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="scoring-type" appearance="fill">
                    <mat-select formControlName="questiondisplayoptions">
                      <mat-option [value]="option.title" *ngFor="let option of QuestionOrientation">{{option.title}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </div>
  <div *ngIf="displayQuestionType">
    <app-choose-question-type></app-choose-question-type>
  </div>
</div>

<div *ngIf="isListMode">
  <app-question-list></app-question-list>
</div>
